import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moveUp: {
		id: 'business-list.list-view.select-row-cell.drag-handle.move-up',
		defaultMessage: 'Move issue up',
		description: 'Label for the button that allows the users to move items up in the table',
	},
	movetoTop: {
		id: 'business-list.list-view.select-row-cell.drag-handle.moveto-top',
		defaultMessage: 'Move issue to the top',
		description: 'Label for the button that allows the users to move items to the top of the table',
	},
	moveDown: {
		id: 'business-list.list-view.select-row-cell.drag-handle.move-down',
		defaultMessage: 'Move issue down',
		description: 'Label for the button that allows the users to move items up in the table',
	},
	moveToBottom: {
		id: 'business-list.list-view.select-row-cell.drag-handle.move-to-bottom',
		defaultMessage: 'Move issue to the bottom',
		description:
			'Label for the button that allows the users to move items to the bottom ofthe table',
	},
	addParent: {
		id: 'business-list.list-view.select-row-cell.drag-handle.add-parent',
		defaultMessage: 'Add parent',
		description: 'Label for the button that allows the users to add a parent to the item',
	},
	changeParent: {
		id: 'business-list.list-view.select-row-cell.drag-handle.change-parent',
		defaultMessage: 'Change parent',
		description: 'Label for the button that allows the users to change the parent of the item',
	},
	reorder: {
		id: 'business-list.list-view.select-row-cell.drag-handle.reorder',
		defaultMessage: 'Reorder',
		description: 'Label for the button that allows the users to reorder items in a table',
	},
});
